import { render, staticRenderFns } from "./PolicyDetails_Pension.vue?vue&type=template&id=64df912c&"
import script from "./PolicyDetails_Pension.vue?vue&type=script&lang=ts&"
export * from "./PolicyDetails_Pension.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyDetails_Pension.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports